import produce from 'immer'
import { assign } from 'lodash'

import { areSameValue } from '../../../core/utils'

import { UPDATE_MENU_TITLE } from '../../../menu-title/redux/action-types'
import {
  ASSIGN_MENU_CURATION_TASK_USER,
  DOWNLOAD_MENU_DOCUMENT,
  DUPLICATE_MENU_CURATION_TASK,
  FETCH_LOCATION_NAMES,
  FETCH_MENU_CURATION_TASK,
  FETCH_MENU_CURATION_TASK_HISTORY,
  FETCH_SCRAPING_REVIEW_COMMENTS,
  REFRESH_MENU_CURATION_TASK,
  REFRESH_MENU_CURATION_TASK_COUNTS,
  REMOVE_FROM_ALLOCATION,
  REOPEN_MENU_CURATION_TASK,
  REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW,
  RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION,
  RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS,
  UNLOCK_MENU_CURATION_TASK_DISHES,
  UPDATE_MENU_CURATION_TASK,
  UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS,
  UPDATE_MENU_CURATION_TASK_STATUS_FLAG,
} from '../action-types'
import { MENU_CURATION_TASK_INITIAL_STATE } from '../initial-states'

const menuCurationTaskReducer = (
  state = MENU_CURATION_TASK_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_MENU_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case REFRESH_MENU_CURATION_TASK.COMPLETE:
    case FETCH_MENU_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { menuCurationTask } = action.payload.data

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: menuCurationTask,
        })
      })

    case REFRESH_MENU_CURATION_TASK.FAIL:
    case FETCH_MENU_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case FETCH_MENU_CURATION_TASK.CLEANUP:
      return { ...MENU_CURATION_TASK_INITIAL_STATE }

    case ASSIGN_MENU_CURATION_TASK_USER.START:
      return produce(state, nextState => {
        if (areSameValue(action.payload?.id, state.data?.id)) {
          assign(nextState, {
            isUpdateLoading: true,
          })
        }
      })

    case ASSIGN_MENU_CURATION_TASK_USER.COMPLETE:
      return produce(state, nextState => {
        const { assignUserToMenuCurationTask: menuCurationTask } =
          action.payload.data

        if (areSameValue(menuCurationTask?.id, state.data?.id)) {
          assign(nextState.data, menuCurationTask)
          assign(nextState, {
            isUpdateLoading: false,
          })
        }
      })

    case ASSIGN_MENU_CURATION_TASK_USER.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case REMOVE_FROM_ALLOCATION.START:
      return produce(state, nextState => {
        if (areSameValue(action.payload?.id, state.data?.id)) {
          assign(nextState, {
            isUpdateLoading: true,
          })
        }
      })

    case REMOVE_FROM_ALLOCATION.COMPLETE:
      return produce(state, nextState => {
        const { removeFromAllocation: menuCurationTask } = action.payload.data

        if (areSameValue(menuCurationTask?.id, state.data?.id)) {
          assign(nextState.data, menuCurationTask)
          assign(nextState, {
            isUpdateLoading: false,
          })
        }
      })

    case REMOVE_FROM_ALLOCATION.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW.START:
      return produce(state, nextState =>
        assign(nextState, {
          isRequestScrapingReviewLoading: true,
          updateError: null,
        }),
      )

    case UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateScrapingReviewStatusLoading: true,
          updateError: null,
        }),
      )

    case UPDATE_MENU_CURATION_TASK_STATUS_FLAG.START:
    case RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION.START:
    case RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS.START:
    case REOPEN_MENU_CURATION_TASK.START:
    case UNLOCK_MENU_CURATION_TASK_DISHES.START:
    case UPDATE_MENU_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: true,
          updateError: null,
        }),
      )

    case REOPEN_MENU_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { reopenMenuCurationTask: menuCurationTask } = action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UNLOCK_MENU_CURATION_TASK_DISHES.COMPLETE:
      return produce(state, nextState => {
        const { unlockMenuCurationTaskDishes: menuCurationTask } =
          action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION.COMPLETE:
      return produce(state, nextState => {
        const { retryMenuCurationTaskAutomaticCuration: awaitingStatus } =
          action.payload.data

        assign(nextState.data, { awaitingStatus })
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS.COMPLETE:
      return produce(state, nextState => {
        const { retryMenuCurationTaskLabelsAndIngredients: awaitingStatus } =
          action.payload.data

        assign(nextState.data, { awaitingStatus })
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_MENU_TITLE.COMPLETE:
      return produce(state, nextState => {
        const { updateMenuTitle: menuTitleNodes } = action.payload.data

        assign(nextState.data.menu.menuTitles, menuTitleNodes)
      })

    case UPDATE_MENU_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { updateMenuCurationTask: menuCurationTask } = action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_MENU_CURATION_TASK_STATUS_FLAG.COMPLETE:
      return produce(state, nextState => {
        const { updateMenuCurationTaskStatusFlag: menuCurationTask } =
          action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS.COMPLETE:
      return produce(state, nextState => {
        const { updateMenuCurationTaskScrapingReviewStatus: menuCurationTask } =
          action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isUpdateScrapingReviewStatusLoading: false,
          updateError: null,
        })
      })

    case REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW.COMPLETE:
      return produce(state, nextState => {
        const { requestMenuCurationTaskScrapingReview: menuCurationTask } =
          action.payload.data

        assign(nextState.data, menuCurationTask)
        assign(nextState, {
          isRequestScrapingReviewLoading: false,
          updateError: null,
        })
      })

    case REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW.FAIL:
      return produce(state, nextState => {
        assign(nextState, {
          isRequestScrapingReviewLoading: false,
          updateError: action.error.message,
        })
      })

    case UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS.FAIL:
    case UPDATE_MENU_CURATION_TASK_STATUS_FLAG.FAIL:
    case REOPEN_MENU_CURATION_TASK.FAIL:
    case UNLOCK_MENU_CURATION_TASK_DISHES.FAIL:
    case RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION.FAIL:
    case RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS.FAIL:
    case UPDATE_MENU_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case REFRESH_MENU_CURATION_TASK_COUNTS.COMPLETE:
      return produce(state, nextState => {
        const { menuCurationTask } = action.payload.data

        assign(nextState.data, menuCurationTask)
      })

    case FETCH_LOCATION_NAMES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLocationNamesLoading: true,
          locationNamesError: undefined,
          locationNames: {},
        }),
      )

    case FETCH_LOCATION_NAMES.COMPLETE:
      return produce(state, nextState => {
        const { locationNames } = action.payload.data

        return assign(nextState, {
          isLocationNamesLoading: false,
          locationNamesError: undefined,
          locationNames,
        })
      })

    case FETCH_LOCATION_NAMES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLocationNamesLoading: false,
          locationNamesError: action.error.message,
          locationNames: {},
        }),
      )

    case DUPLICATE_MENU_CURATION_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isDuplicateLoading: true,
          duplicateError: null,
        }),
      )

    case DUPLICATE_MENU_CURATION_TASK.COMPLETE:
      return produce(state, nextState => {
        const { duplicateBrandCurationTask: brandCurationTask } =
          action.payload.data

        assign(nextState.data, brandCurationTask)
        assign(nextState, {
          isDuplicateLoading: false,
          duplicateError: null,
        })
      })

    case DUPLICATE_MENU_CURATION_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isDuplicateLoading: false,
          duplicateError: action.error.message,
        }),
      )

    case FETCH_MENU_CURATION_TASK_HISTORY.START:
      return produce(state, nextState => {
        assign(nextState.history, {
          isLoading: true,
          error: undefined,
          data: {},
        })
      })

    case FETCH_MENU_CURATION_TASK_HISTORY.COMPLETE:
      return produce(state, nextState => {
        const { history } = action.payload.data

        assign(nextState.history, {
          isLoading: false,
          error: undefined,
          data: history,
        })
      })

    case FETCH_MENU_CURATION_TASK_HISTORY.FAIL:
      return produce(state, nextState => {
        assign(nextState.history, {
          isLoading: false,
          error: action.error.message,
          data: {},
        })
      })

    case FETCH_SCRAPING_REVIEW_COMMENTS.START:
      return produce(state, nextState => {
        assign(nextState.scrapingReviewComments, {
          isLoading: true,
          error: undefined,
          data: {},
        })
      })

    case FETCH_SCRAPING_REVIEW_COMMENTS.COMPLETE:
      return produce(state, nextState => {
        const { scrapingReviewComments } = action.payload.data

        assign(nextState.scrapingReviewComments, {
          isLoading: false,
          error: undefined,
          data: scrapingReviewComments,
        })
      })

    case FETCH_SCRAPING_REVIEW_COMMENTS.FAIL:
      return produce(state, nextState => {
        assign(nextState.scrapingReviewComments, {
          isLoading: false,
          error: action.error.message,
          data: {},
        })
      })

    case DOWNLOAD_MENU_DOCUMENT.START:
      return produce(state, nextState =>
        assign(nextState, {
          isMenuDocumentDownloading: true,
          menuDocumentDownloadError: undefined,
        }),
      )

    case DOWNLOAD_MENU_DOCUMENT.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isMenuDocumentDownloading: false,
          menuDocumentDownloadError: undefined,
        }),
      )

    case DOWNLOAD_MENU_DOCUMENT.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isMenuDocumentDownloading: false,
          menuDocumentDownloadError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default menuCurationTaskReducer
